<template>
  <div
    class="a-cover lg:w-144 pb-8 bg-white overflow-y-auto transition"
    :class="{ 'sidebar-closed': !sidebarOpen }"
  >
    <div class="flex flex-col justify-between p-x bg-grey-2">
      <div class="flex-a justify-between h-10 md:h-12">
        <BtnBack
          icon="BackIcon"
          aria="Back"
          text="Back"
          iconsize="1.5rem"
          textsize="base"
          iconcolor="primary"
          textcolor="primary"
          class="font-bold"
        />
        <Button
          icon="BackIcon"
          type="button"
          iconsize="1.5rem"
          iconcolor="primary"
          data-gtm-category-sidebar-toggle
          :aria="sidebarOpen ? 'Hide content' : 'Show Content'"
          :aria-expanded="sidebarOpen || false"
          aria-controls="content-panel"
          :iconrotation="sidebarOpen ? 'rotate-270' : 'rotate-90'"
          class="h-6"
          @buttonClick="sidebarOpen = !sidebarOpen"
        />
      </div>
      <Menu
        :menuitems="categories"
        :category="category"
        arialabel="Areas of interest"
      />
    </div>
    <section
      id="content-panel"
      :aria-label="category.title"
      :aria-hidden="!sidebarOpen"
      class="transition"
      :class="{ hidden: !sidebarOpen }"
    >
      <Category v-if="!isSubjectList" :category="category" />
      <Subjects v-if="isSubjectList" :category="category" />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Subjects from '@/components/Subjects.vue'
import Category from '@/components/Category.vue'
import Menu from '@/components/Menu.vue'
import BtnBack from '@/components/buttons/BtnBack.vue'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Categories',

  components: {
    Subjects,
    Category,
    Menu,
    BtnBack,
    Button
  },

  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      sidebarOpen: true
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['categories']),

    isSubjectList() {
      return this.category.slug === 'subjects'
    }
  },

  watch: {
    sidebarOpen: {
      immediate: true,
      handler(value) {
        this.$store.commit('toggleCategoriesState', value)
      }
    }
  },

  created() {
    if (this.mobile) {
      this.sidebarOpen = false
    }
  }
}
</script>
